import { Injectable } from '@angular/core';
import { BrokerService } from './broker.service';
import { LoadingService } from './loading.service';
import { SesionService } from './sesion.service';
import { OneShotPay, UnDiaRequest } from '../models/change.model';
import { ModalService } from './modal.service';
import { environment } from '../../environments/environment';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class ChangeService {

  precioOS: any;
  dataPago: any;
  recaptcha: any;
  errorMessage: any;
  dataUndia: any;

  constructor(
    public broker: BrokerService,
    private sesion: SesionService,
    private loading: LoadingService,
    private modal: ModalService
  ) { }

  consultarPrecio() {

    const body = JSON.stringify({
      id: 'ONES',
      name: 'ONES1',
      format: 1
    });

    this.broker.checkPlanPrice( body ).subscribe( (resp: any) => {
      this.precioOS = resp.price;
    });
  }

  resolved(captchaResponse: string) {
    if (!this.recaptcha) {
      this.recaptcha = captchaResponse;
    }
  }

  pagarOneshot() {
    this.loading.open('Por favor espera un momento ...', 'Estamos redirigiendo a la plataforma de pagos');
    this.errorMessage = null;

    // if ( this.recaptcha) {
      const body = JSON.stringify({
        idNumber: '',
        typeDocument: 1,
        cellPhone: '',
        name: '',
        surname: '',
        email: '',
        recaptcha: this.recaptcha,
        sessionId:  this.sesion.getCookie(),
        utm: this.sesion.getCookieServices('UTMC')
      });

      this.broker.oneshotRequest( body ).subscribe( (resp: any) => {
        this.dataPago = resp;
        //console.log("jajaja ", resp)
        //this.sesion.deleteCookie();
        setTimeout( () => {
          this.loading.close();
          $('input#formOneshot').click();
        }, 3000);
      },
      (error) => {
        this.loading.close();
        this.cerrarSesion();
        this.recaptcha = null;
        if ( error.status === 406 ) {
          this.modal.open(
            '¡Lo sentimos!',
            // tslint:disable-next-line: max-line-length
            '<p>No cuentas con suficiente información crediticia para generar un reporte con tu Puntaje y resumen de tu Historia de Crédito</p>',
            'assets/images/icons/bad.svg',
            false,
            '',
            'Volver a intentar',
            'modal-error'
          );
        } else {
          this.modal.open(
            '¡Lo sentimos!',
            '<p>Hubo un error en la información enviada, verifica y vuelve a intentarlo.</p>',
            'assets/images/icons/bad.svg',
            false,
            '',
            'Volver a intentar',
            'modal-error'
          );
        }
      });
    // } else {
    //   this.recaptcha = null;
    //   this.loading.close();
    //   this.errorMessage = 'Validar captcha.';
    // }
  }

  cerrarSesion() {
    this.broker.cerrarSesion().subscribe( (resp: any) => {
      this.sesion.deleteCookie();
    },
      (error) => {
          this.sesion.deleteCookie();
      }
    );
  }

  activarUndia( promocode: string ) {
    this.loading.open('Por favor espera un momento ...', 'Estamos validando tu información');
    this.errorMessage = null;

    this.dataUndia = {
      action: 'GIFTCARD',
      session: this.sesion.getCookie(),
      params: {
        test: environment.production,
        giftcardCode: promocode,
        planCode: 'PER4'
      }
    };

    const body = JSON.stringify( this.dataUndia );

    this.broker.undiaPromocode( body ).subscribe( (resp) => {
      setTimeout( () => {
        this.loading.close();
        this.modal.open(
          '¡Código válido!',
          '<p>Tu plan ha sido activado satisfactoriamente.</p>',
          'assets/images/icons/ok.svg',
          false,
          environment.validLogin_midc,
          'Ir a Midatacrédito',
          'modal-confirm'
        );
      }, 2000);
    },
    (error) => {
      this.cerrarSesion();
      this.loading.close();
      this.modal.open(
        'No pudimos activar tu plan satisfactoriamente',
        '<p>Código promocional no válido, verifica y vuelve a intentarlo.</p>',
        'assets/images/icons/bad.svg',
        false,
        '',
        'Volver a intentar',
        'modal-error'
      );
    });
  }
}
